/**
 * FAQ Page
 */
function faqPage(opts) {
  const config = {
    dom: {
      contact: 'contact-us',
      main: 'faq',
      gladly: {
        answer: 'gladlyHC-answerDetail',
        back: 'gladlyHC-answerDetail',
        item: 'gladlyHC-faqSection-listItem',
        main: 'gladlyHC-faq',
        title: 'js-gladly-title',
        wrapper: 'js-gladly-faq',
      },
    },
    cls: {
      hide: 'hide',
    },
    text: {
      gladly_title_default: 'All FAQ',
      gladly_title_answer: 'Frequently Asked Questions',
    },
  };

  // Shorthand config
  const c = __.extend(config, opts); // Extend defaults with passed options

  // cached global(s)
  const $main = document.getElementById(c.dom.main);

  /**
   * Init
   */
  function init() {
    if (!$main) return;

    // reset Gladly widget on page load
    toggleGladlyWidget(true);

    addEvents();
  }

  /**
   * Add Events
   */
  function addEvents() {
    setTimeout(() => {
      addGladlyFaqEvent();
    }, 1000); // timeout to wait for initial Gladly widget render
  }

  /**
   * Add Gladly FAQ Event
   */
  function addGladlyFaqEvent() {
    const $gladlyWrapper = $main.querySelector(`.${c.dom.gladly.wrapper}`);
    if (!$gladlyWrapper) return;

    const $gladlyMain = $gladlyWrapper.querySelector(`.${c.dom.gladly.main}`)
      || $gladlyWrapper.querySelector(`.${c.dom.gladly.answer}`);
    if (!$gladlyMain) return;

    // only one of these elements should be found when this function runs
    const $gladlyBackBtn = $gladlyMain.querySelector(`.${c.dom.gladly.back} a`);
    const $gladlyItemLink = $gladlyMain.querySelector(`.${c.dom.gladly.item} a`);

    if ($gladlyBackBtn) {
      toggleGladlyWidget(false);

      __.addEvent({
        id: $gladlyMain,
        className: `${c.dom.gladly.back} a`,
        event: 'click',
        fn: () => {
          toggleGladlyWidget(true);
          setTimeout(addGladlyFaqEvent, 250); // short timeout for Gladly widget
        },
      });
    } else if ($gladlyItemLink) {
      toggleGladlyWidget(true);

      __.addEvent({
        id: $gladlyMain,
        className: `${c.dom.gladly.item} a`,
        event: 'click',
        fn: () => {
          toggleGladlyWidget(false);
          setTimeout(addGladlyFaqEvent, 250); // short timeout for Gladly widget
        },
      });
    }
  }

  /**
   * Toggle Gladly Widget
   * @param {Boolean} shouldReset
   */
  function toggleGladlyWidget(shouldReset) {
    const $gladlyTitle = $main.querySelector(`.${c.dom.gladly.title}`);
    const $contactUsSection = $main.querySelector(`.${c.dom.contact}`);

    // toggle Gladly title text content
    if ($gladlyTitle) {
      $gladlyTitle.innerHTML = shouldReset
        ? c.text.gladly_title_default
        : c.text.gladly_title_answer;
    }

    // toggle "Contact Us" section, should only display for answer state
    if ($contactUsSection) {
      if (shouldReset) {
        __.addClass($contactUsSection, c.cls.hide);
      } else {
        __.removeClass($contactUsSection, c.cls.hide);
      }
    }
  }

  return init();
}

export default faqPage;
